module.exports = __webpack_public_path__ + "static/img/g2.3330306.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/g2.png
// module id = nIYv
// module chunks = 0